module.exports = __webpack_public_path__ + "static/media/Search Sanctions Kurum Adı.e2adfad6.xlsx";